import { supabase } from '../lib/supabase';

// ---- Converters ----

const toSubCamel = (row) => ({
  id: row?.id,
  name: row?.name,
  contactName: row?.contact_name || '',
  contactEmail: row?.contact_email || '',
  contactPhone: row?.contact_phone || '',
  companyAddress: row?.company_address || '',
  website: row?.website || '',
  types: row?.types || [],
  createdAt: row?.created_at,
  updatedAt: row?.updated_at,
});

const toSubSnake = (c) => ({
  name: c?.name,
  contact_name: c?.contactName || null,
  contact_email: c?.contactEmail || null,
  contact_phone: c?.contactPhone || null,
  company_address: c?.companyAddress || null,
  website: c?.website || null,
  types: c?.types || [],
});

const toTypeCamel = (row) => ({
  id: row?.id,
  label: row?.label,
  sortOrder: row?.sort_order,
});

// ---- Sub-Contractors ----

export const getSubContractors = async () => {
  const { data, error } = await supabase?.from('sub_contractors')?.select('*')?.order('name', { ascending: true });
  if (error) throw error;
  return (data || [])?.map(toSubCamel);
};

export const createSubContractor = async (item) => {
  const { data, error } = await supabase?.from('sub_contractors')?.insert(toSubSnake(item))?.select()?.single();
  if (error) throw error;
  return toSubCamel(data);
};

export const updateSubContractor = async (id, item) => {
  const { data, error } = await supabase?.from('sub_contractors')?.update(toSubSnake(item))?.eq('id', id)?.select()?.single();
  if (error) throw error;
  return toSubCamel(data);
};

export const deleteSubContractor = async (id) => {
  const { error } = await supabase?.from('sub_contractors')?.delete()?.eq('id', id);
  if (error) throw error;
};

// ---- Sub-Contractor Types ----

export const getSubContractorTypes = async () => {
  const { data, error } = await supabase?.from('sub_contractor_types')?.select('*')?.order('sort_order', { ascending: true });
  if (error) throw error;
  return (data || [])?.map(toTypeCamel);
};

export const createSubContractorType = async (label) => {
  const { data: existing } = await supabase?.from('sub_contractor_types')?.select('sort_order')?.order('sort_order', { ascending: false })?.limit(1);
  const sortOrder = existing?.length ? (existing?.[0]?.sort_order + 1) : 0;
  const { data, error } = await supabase?.from('sub_contractor_types')?.insert({ label: label?.trim(), sort_order: sortOrder })?.select()?.single();
  if (error) throw error;
  return toTypeCamel(data);
};

export const updateSubContractorType = async (id, label) => {
  const { data, error } = await supabase?.from('sub_contractor_types')?.update({ label: label?.trim() })?.eq('id', id)?.select()?.single();
  if (error) throw error;
  return toTypeCamel(data);
};

export const deleteSubContractorType = async (id) => {
  const { error } = await supabase?.from('sub_contractor_types')?.delete()?.eq('id', id);
  if (error) throw error;
};
